import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '@/components/upload/uploadFile';
import { submitProjectDeliveryHandle, submitProjectHandle, submitBiddingHandle, submitCardAndCouponDesignHandle, getTaskInfo, searchUserList } from '../../api';
import { uploadFile as uploadApi } from '@/components/upload/upload';
export default {
  components: {
    UploadFile: UploadFile
  },
  data: function data() {
    return {
      processDialogVisible: false,
      processForm: {
        id: null,
        status: [],
        remarks: ''
      },
      processRules: {
        status: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择处理结果',
          trigger: 'change'
        }]
      },
      biddingDialogVisible: false,
      biddingForm: {
        id: null,
        bid_files: [],
        is_check: '',
        check_person_id: null,
        check_person_name: '',
        remarks: ''
      },
      biddingRules: {
        bid_files: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请上传投标文件',
          trigger: 'change'
        }],
        is_check: [{
          required: true,
          message: '请选择是否检查',
          trigger: 'change'
        }],
        check_person_id: [{
          required: true,
          message: '请选择检查人',
          trigger: 'change'
        }]
      },
      // 人员下拉远程搜索：按下拉字段隔离选项，已选项缓存记录 id→选项（换关键字后已选标签不退化）
      personOptions: {},
      personOptionCache: {},
      personLoading: false,
      biddingImageSrcList: [],
      projectDialogVisible: false,
      projectForm: {
        id: null,
        bid_status: '',
        abandon_reason: '',
        remarks: ''
      },
      projectRules: {
        bid_status: [{
          required: true,
          message: '请选择投标状态',
          trigger: 'change'
        }]
      },
      cardAndCouponDesignDialogVisible: false,
      cardAndCouponDesignForm: {
        id: null,
        design_complexity: '',
        design_img: [],
        remarks: ''
      },
      cardAndCouponDesignRules: {
        design_complexity: [{
          required: true,
          message: '请选择设计复杂度',
          trigger: 'change'
        }],
        design_img: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请上传设计稿',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    openProcess: function openProcess(id) {
      var _this = this;
      this.processForm.id = id;
      this.processForm.status = [];
      this.processForm.remarks = '';
      this.processDialogVisible = true;
      this.$nextTick(function () {
        _this.$refs.processForm.clearValidate();
      });
    },
    submitProcess: function submitProcess() {
      var _this2 = this;
      this.$refs.processForm.validate(function (valid) {
        if (valid) {
          _this2.submitFn();
        }
      });
    },
    submitFn: function submitFn() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var obj, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              obj = {
                id: _this3.processForm.id,
                status: 1,
                remarks: _this3.processForm.remarks
              };
              _context.n = 1;
              return submitProjectDeliveryHandle(obj);
            case 1:
              res = _context.v;
              _this3.$message.success('处理成功');
              _this3.processDialogVisible = false;
              _this3.$emit('success');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    openBidding: function openBidding(id) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, detail, preset;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this4.biddingForm.id = id;
              _this4.biddingForm.bid_files = [];
              _this4.biddingForm.is_check = '';
              _this4.biddingForm.check_person_id = null;
              _this4.biddingForm.check_person_name = '';
              _this4.biddingForm.remarks = '';
              _this4.biddingDialogVisible = true;
              _context2.n = 1;
              return getTaskInfo({
                item_id: id
              });
            case 1:
              res = _context2.v;
              detail = res.data || {};
              _this4.biddingForm.bid_files = Array.isArray(detail.bid_files) ? detail.bid_files : detail.bid_files ? JSON.parse(detail.bid_files) : [];
              _this4.biddingForm.is_check = String(detail.is_check || '');
              _this4.biddingForm.check_person_id = detail.check_person_id || null;
              _this4.biddingForm.check_person_name = detail.check_person_name || '';
              // 已选检查人回填选项：选项列表为空时下拉标签会退化成 ID
              if (detail.check_person_id) {
                preset = {
                  id: detail.check_person_id,
                  name: detail.check_person_name || '',
                  nick_name: detail.check_person_name || ''
                };
                _this4.personOptionCache[String(preset.id)] = preset;
                _this4.$set(_this4.personOptions, 'checkPerson', [preset]);
              }
              _this4.biddingForm.remarks = detail.remarks || '';
              _this4.updateBiddingImageSrcList();
              _this4.$nextTick(function () {
                _this4.$refs.biddingForm.clearValidate();
              });
              // 打开弹窗时预载检查人选项（空关键词返回默认列表）
              _this4.searchCheckPerson('');
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    submitBiddingProcess: function submitBiddingProcess() {
      var _this5 = this;
      this.$refs.biddingForm.validate(function (valid) {
        if (valid) {
          _this5.submitBiddingFn();
        }
      });
    },
    submitBiddingFn: function submitBiddingFn() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var obj, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              obj = {
                id: _this6.biddingForm.id,
                bid_files: _this6.biddingForm.bid_files,
                is_check: _this6.biddingForm.is_check,
                check_person_id: _this6.biddingForm.check_person_id,
                check_person_name: _this6.biddingForm.check_person_name,
                remarks: _this6.biddingForm.remarks
              };
              _context3.n = 1;
              return submitBiddingHandle(obj);
            case 1:
              res = _context3.v;
              _this6.$message.success('上传标书成功');
              _this6.biddingDialogVisible = false;
              _this6.$emit('success');
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    handleCheckPersonChange: function handleCheckPersonChange() {
      var _this7 = this;
      var selected = (this.personOptions.checkPerson || []).find(function (item) {
        return String(item.id) === String(_this7.biddingForm.check_person_id);
      });
      this.biddingForm.check_person_name = selected ? selected.name || selected.nick_name || '' : '';
    },
    // 人员下拉通用远程搜索：结果按字段存进 personOptions，已选项从缓存回填
    searchPerson: function searchPerson(keyword, field, valueGetter) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var kw, res, list, selected, picked;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              kw = (keyword || '').trim();
              _this8.personLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return searchUserList({
                keyword: kw
              });
            case 2:
              res = _context4.v;
              list = res.data || [];
              list.forEach(function (item) {
                _this8.personOptionCache[String(item.id)] = item;
              });
              // 结果并入已选项：换关键字会销毁旧 option，已选标签需继续有数据可查
              selected = valueGetter();
              if (!Array.isArray(selected)) {
                selected = selected === undefined || selected === null || selected === '' ? [] : [selected];
              }
              picked = selected.filter(function (id) {
                return !list.some(function (item) {
                  return String(item.id) === String(id);
                });
              }).map(function (id) {
                return _this8.personOptionCache[String(id)];
              }).filter(Boolean);
              _this8.$set(_this8.personOptions, field, picked.concat(list));
            case 3:
              _context4.p = 3;
              _this8.personLoading = false;
              return _context4.f(3);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[1,, 3, 4]]);
      }))();
    },
    // 检查人（投标支持）
    searchCheckPerson: function searchCheckPerson(keyword) {
      var _this9 = this;
      return this.searchPerson(keyword, 'checkPerson', function () {
        return _this9.biddingForm.check_person_id;
      });
    },
    // 清空检查人：重置名称并恢复默认选项列表
    handleCheckPersonClear: function handleCheckPersonClear() {
      this.biddingForm.check_person_name = '';
      this.searchCheckPerson('');
    },
    isBiddingFileImage: function isBiddingFileImage(item) {
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
      var fileExtension = (item.url || item.file_name || '').split('.').pop().toLowerCase();
      return imageExtensions.includes(fileExtension);
    },
    handleBiddingFileUploaded: function handleBiddingFileUploaded(key, url, fileName, uid) {
      var fileItem = {
        file_name: fileName,
        url: key
      };
      this.biddingForm.bid_files.push(fileItem);
      this.$refs.biddingForm.validateField('bid_files');
      this.updateBiddingImageSrcList();
    },
    deleteBiddingFile: function deleteBiddingFile(index) {
      this.biddingForm.bid_files.splice(index, 1);
      this.$refs.biddingForm.validateField('bid_files');
      this.updateBiddingImageSrcList();
    },
    updateBiddingImageSrcList: function updateBiddingImageSrcList() {
      var _this0 = this;
      this.biddingImageSrcList = this.biddingForm.bid_files.filter(function (item) {
        return _this0.isBiddingFileImage(item);
      }).map(function (item) {
        return _this0.$ossurl + item.url;
      });
    },
    downBiddingFile: function downBiddingFile(url, fileName) {
      this.$message.success('文件处理中…');
      var fullUrl = /^(https?:)?\/\//.test(url) ? url : this.$ossurl + url;
      var baseName = fileName || url.split('/').pop().split('?')[0];
      var ext = (url.split('?')[0].split('.').pop() || '').toLowerCase();
      var finalName = ext && !baseName.toLowerCase().endsWith('.' + ext) ? baseName + '.' + ext : baseName;
      fetch(fullUrl).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var objectUrl = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = objectUrl;
        link.download = finalName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
      }).catch(function () {
        window.open(fullUrl, '_blank');
      });
    },
    openProject: function openProject(id) {
      var _this1 = this;
      this.projectForm.id = id;
      this.projectForm.bid_status = '';
      this.projectForm.abandon_reason = '';
      this.projectForm.remarks = '';
      this.projectDialogVisible = true;
      this.$nextTick(function () {
        _this1.$refs.projectForm.clearValidate();
      });
    },
    submitProjectProcess: function submitProjectProcess() {
      var _this10 = this;
      this.$refs.projectForm.validate(function (valid) {
        if (valid) {
          _this10.submitProjectFn();
        }
      });
    },
    submitProjectFn: function submitProjectFn() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var obj, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              obj = {
                id: _this11.projectForm.id,
                status: Number(_this11.projectForm.bid_status),
                abandon_reason: _this11.projectForm.bid_status === '2' ? _this11.projectForm.abandon_reason : '',
                remarks: _this11.projectForm.remarks
              };
              _context5.n = 1;
              return submitProjectHandle(obj);
            case 1:
              res = _context5.v;
              _this11.$message.success('处理成功');
              _this11.projectDialogVisible = false;
              _this11.$emit('success');
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    // 打开定制设计印刷处理弹窗
    openCardAndCouponDesign: function openCardAndCouponDesign(id) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res, detail;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this12.cardAndCouponDesignForm.id = id;
              _this12.cardAndCouponDesignForm.design_complexity = '';
              _this12.cardAndCouponDesignForm.design_img = [];
              _this12.cardAndCouponDesignForm.confirm = '';
              _this12.cardAndCouponDesignForm.remarks = '';
              _this12.cardAndCouponDesignDialogVisible = true;
              // 获取任务详情回填弹窗（设计复杂度/设计稿/备注）
              // 详情返回字段名与提交参数不同：design_draft（数组）对应表单 design_img，remark 对应 remarks
              _context6.n = 1;
              return getTaskInfo({
                item_id: id
              });
            case 1:
              res = _context6.v;
              detail = res.data || {}; // radio 的 label 为数字，接口返回字符串（如 "3"），需转为数字保证回显选中
              _this12.cardAndCouponDesignForm.design_complexity = detail.design_complexity ? Number(detail.design_complexity) : '';
              // design_draft 接口返回数组，兼容 JSON 字符串格式兜底
              if (Array.isArray(detail.design_draft)) {
                _this12.cardAndCouponDesignForm.design_img = detail.design_draft;
              } else if (detail.design_draft) {
                try {
                  _this12.cardAndCouponDesignForm.design_img = JSON.parse(detail.design_draft);
                } catch (e) {
                  _this12.cardAndCouponDesignForm.design_img = [];
                }
              }
              _this12.cardAndCouponDesignForm.remarks = detail.remark || '';
              _this12.$nextTick(function () {
                _this12.$refs.cardAndCouponDesignForm.clearValidate();
              });
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    cardAndCouponDesignUploadFile: function cardAndCouponDesignUploadFile() {
      this.$refs.cardAndCouponDesignUploadBanner.uploadBanner();
    },
    cardAndCouponDesignEmitUploadFile: function cardAndCouponDesignEmitUploadFile(url, val, name) {
      var fileItem = {
        file_name: name,
        url: url,
        uid: new Date().getTime(),
        status: 'success'
      };
      this.addCardAndCouponDesignFile(fileItem);
    },
    addCardAndCouponDesignFile: function addCardAndCouponDesignFile(fileItem) {
      if (this.cardAndCouponDesignForm.design_img.length >= 9) {
        this.$message.warning('粘贴截图上传不能超过9张');
        return;
      }
      this.cardAndCouponDesignForm.design_img.push(fileItem);
      this.$refs.cardAndCouponDesignForm.validateField('design_img');
    },
    cardAndCouponDesignIsImage: function cardAndCouponDesignIsImage(item) {
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
      var fileExtension = (item.url || item.file_name || '').split('.').pop().toLowerCase();
      return imageExtensions.includes(fileExtension);
    },
    cardAndCouponDesignGetFileName: function cardAndCouponDesignGetFileName(item) {
      return item.file_name;
    },
    cardAndCouponDesignGetOriginalIndex: function cardAndCouponDesignGetOriginalIndex(item) {
      return this.cardAndCouponDesignForm.design_img.findIndex(function (el) {
        return el === item;
      });
    },
    cardAndCouponDesignDelStyleImage: function cardAndCouponDesignDelStyleImage(index) {
      this.cardAndCouponDesignForm.design_img.splice(index, 1);
      this.$refs.cardAndCouponDesignForm.validateField('design_img');
    },
    cardAndCouponDesignIsPdf: function cardAndCouponDesignIsPdf(item) {
      var fileExtension = (item.url || item.file_name || '').split('.').pop().toLowerCase();
      return fileExtension === 'pdf';
    },
    cardAndCouponDesignOpenFile: function cardAndCouponDesignOpenFile(item) {
      window.open(this.$ossurl + item.url, '_blank');
    },
    handleCardAndCouponDesignPaste: function handleCardAndCouponDesignPaste(event) {
      if (this.cardAndCouponDesignForm.design_img.length >= 9) {
        this.$message.warning('粘贴截图上传不能超过9张');
        return;
      }
      var items = event.clipboardData.items;
      var _iterator = _createForOfIteratorHelper(items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.type.indexOf('image') !== -1) {
            var file = item.getAsFile();
            if (file) {
              this.cardAndCouponDesignUploadFileFromPaste(file);
            }
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    cardAndCouponDesignUploadFileFromPaste: function cardAndCouponDesignUploadFileFromPaste(file) {
      var _this13 = this;
      if (this.cardAndCouponDesignForm.design_img.length >= 9) {
        this.$message.warning('粘贴截图上传不能超过9张');
        return;
      }
      var loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      uploadApi(file).then(function (response) {
        if (response.status === 200) {
          var fileItem = {
            file_name: file.name,
            url: response.config.key,
            uid: new Date().getTime(),
            status: 'success'
          };
          _this13.addCardAndCouponDesignFile(fileItem);
        } else {
          _this13.$message.error('上传失败');
        }
      }).catch(function (error) {
        _this13.$message.error('上传失败');
      }).finally(function () {
        loading.close();
      });
    },
    submitCardAndCouponDesign: function submitCardAndCouponDesign() {
      var _this14 = this;
      this.$refs.cardAndCouponDesignForm.validate(function (valid) {
        if (valid) {
          _this14.submitCardAndCouponDesignFn();
        }
      });
    },
    submitCardAndCouponDesignFn: function submitCardAndCouponDesignFn() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var obj, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              obj = {
                id: _this15.cardAndCouponDesignForm.id,
                design_complexity: _this15.cardAndCouponDesignForm.design_complexity,
                design_img: _this15.cardAndCouponDesignForm.design_img,
                remarks: _this15.cardAndCouponDesignForm.remarks
              };
              _context7.n = 1;
              return submitCardAndCouponDesignHandle(obj);
            case 1:
              res = _context7.v;
              _this15.$message.success('处理成功');
              _this15.cardAndCouponDesignDialogVisible = false;
              _this15.$emit('success');
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    }
  }
};